(function() {
  // Quantity controls
  window.hydeQty = function(d) {
    var q = document.getElementById('hyde-qty');
    var v = parseInt(q.value) || 1;
    q.value = Math.max(1, v + d);
    updateTotal();
  };
  
  var dataEl = document.getElementById('hyde-pdp-data');
  var data = {};
  if (dataEl) {
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      data = {};
    }
  }

  var baseCents = data.msrpCents || 0;        // selling price of the active variant
  var compareCents = data.compareCents || 0;  // manufacturer compare-at, 0 when none
  var currencyCode = data.currencyCode || 'USD';
  var unitPriceEl = document.getElementById('hyde-unit-price');
  var msrpEl = document.getElementById('hyde-msrp-price');
  var saveEl = document.getElementById('hyde-save-pill');
  var totalEl = document.getElementById('hyde-total');
  var stickyPriceEl = document.getElementById('hyde-sticky-price');
  var tierTableEl = document.getElementById('hyde-tier-table');
  var tierHeadingEl = document.getElementById('hyde-tier-heading');
  var tierContainerEl = document.getElementById('hyde-tier-container');
  var showStandard = data.showStandard !== undefined ? data.showStandard : true;
  var variantSelect = document.getElementById('hyde-variant-select');
  var variantIdInput = document.getElementById('hyde-variant-id');
  var addToCartBtn = document.querySelector('.hyde-pdp__cart-btn');
  var stickyBtn = document.querySelector('.hyde-pdp__sticky-btn');
  var paymentButtonEl = document.querySelector('.shopify-payment-button');
  var stockDotEl = document.querySelector('.hyde-pdp__stock-dot');
  var stockTextEl = document.querySelector('.hyde-pdp__stock-text');
  var shipsEl = document.querySelector('.hyde-pdp__ships');
  var variants = Array.isArray(data.variants) ? data.variants : [];
  var activeVariantId = data.activeVariantId;

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', {style: 'currency', currency: currencyCode});
  }

  var schedule = null;
  var tiers = [];

  function validateScheduleForVariant(variant) {
    schedule = null;
    tiers = [];
    var raw = data.tierEnvelopes ? data.tierEnvelopes[String(variant.id)] : null;
    var formEnvelope = document.getElementById('hyde-form-tier-envelope');
    if (formEnvelope) {
      formEnvelope.textContent = JSON.stringify(raw);
      formEnvelope.dataset.baseCents = String(variant.price);
      formEnvelope.dataset.currency = currencyCode;
      formEnvelope.dataset.currentDate = data.currentDate || '';
    }
    if (!window.HydeTierContract) return;
    var result = window.HydeTierContract.validateScheduleEnvelope(raw, {
      baseCents: variant.price,
      currency: currencyCode,
      currentDate: data.currentDate
    });
    if (result.valid) {
      schedule = result.schedule;
      tiers = result.schedule.tiers;
    }
    var form = document.getElementById('hyde-product-form');
    if (form) window.HydeTierContract.prepareForm(form);
  }

  function getActiveTier(qty) {
    if (!tiers.length) return null;
    var active = null;
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].min) active = tiers[i];
    }
    return active;
  }

  function getUnitPriceCents(tier) {
    if (!tier) return baseCents;
    return window.HydeTierContract
      ? window.HydeTierContract.effectiveUnitPriceCents(tier, baseCents)
      : baseCents;
  }

  function renderTierTable(activeTier) {
    if (!tierTableEl) return;
    if (!tiers.length) {
      tierTableEl.textContent = '';
      if (tierHeadingEl) tierHeadingEl.hidden = true;
      if (tierContainerEl) tierContainerEl.hidden = true;
      return;
    }
    if (tierHeadingEl) tierHeadingEl.hidden = false;
    if (tierContainerEl) tierContainerEl.hidden = false;
    var html = '';
    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i];
      var unitCents = getUnitPriceCents(tier);
      var discounts = unitCents < baseCents;
      if (!showStandard && !discounts) {
        continue;
      }
      var nextMin = (i + 1 < tiers.length) ? tiers[i + 1].min : null;
      var qtyLabel;
      if (!nextMin) {
        qtyLabel = tier.min + '+';
      } else if (nextMin - 1 === tier.min) {
        qtyLabel = String(tier.min);
      } else {
        qtyLabel = tier.min + '–' + (nextMin - 1);
      }
      var isActive = activeTier && tier.min === activeTier.min;
      var saveLabel = tier.discountPct != null && tier.discountPct > 0
        ? ('SAVE ' + tier.discountPct + '%')
        : (discounts ? 'PRO PRICE' : 'Standard price');
      var badge = tier.label ? ('<span class="hyde-pdp__tier-badge">' + tier.label + '</span>') : '';
      html += '<button type="button" class="hyde-pdp__tier-row' + (isActive ? ' is-active' : '') + '"'
        + ' data-min="' + tier.min + '" aria-pressed="' + (isActive ? 'true' : 'false') + '">'
        + '<span class="hyde-pdp__tier-qty">Buy ' + qtyLabel + '</span>'
        + '<span class="hyde-pdp__tier-price">' + formatMoney(unitCents) + ' / ea</span>'
        + '<span class="hyde-pdp__tier-save">' + saveLabel + '</span>'
        + badge
        + '</button>';
    }
    tierTableEl.innerHTML = html;
    tierTableEl.querySelectorAll('.hyde-pdp__tier-row').forEach(function(row) {
      row.addEventListener('click', function() {
        var min = parseInt(row.dataset.min, 10);
        if (isNaN(min)) return;
        var qtyInput = document.getElementById('hyde-qty');
        if (!qtyInput) return;
        qtyInput.value = Math.max(1, min);
        updateTotal();
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function updateTotal() {
    var qtyInput = document.getElementById('hyde-qty');
    if (!qtyInput) return;
    var qty = parseInt(qtyInput.value) || 1;
    var activeTier = getActiveTier(qty);
    var unitCents = getUnitPriceCents(activeTier);
    var total = formatMoney(unitCents * qty);
    if (unitPriceEl) unitPriceEl.textContent = formatMoney(unitCents);
    if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(unitCents);
    if (totalEl) totalEl.textContent = total;
    if (msrpEl) {
      // Struck price: the standard unit price when a tier discount is active,
      // else a real compare-at when it is materially higher (>= $1) than price.
      if (activeTier && unitCents < baseCents) {
        msrpEl.textContent = formatMoney(baseCents);
        msrpEl.hidden = false;
      } else if (compareCents >= baseCents + 100) {
        msrpEl.textContent = formatMoney(compareCents);
        msrpEl.hidden = false;
      } else {
        msrpEl.hidden = true;
      }
    }
    if (saveEl) {
      if (activeTier && unitCents < baseCents) {
        saveEl.hidden = false;
        saveEl.textContent = activeTier.discountPct != null
          ? 'Save ' + activeTier.discountPct + '%'
          : 'Pro price';
      } else {
        saveEl.hidden = true;
        saveEl.textContent = '';
      }
    }
    renderTierTable(activeTier);
  }

  function isBackorder(variant) {
    return !!(variant && variant.available
      && variant.inventory_policy === 'continue'
      && Number(variant.inventory_quantity || 0) <= 0);
  }

  function updateStock(variant) {
    if (!stockDotEl || !stockTextEl || !variant) return;
    var backorder = isBackorder(variant);
    stockDotEl.classList.remove('hyde-pdp__stock-dot--low', 'hyde-pdp__stock-dot--out');
    stockTextEl.classList.remove('hyde-pdp__stock-text--low', 'hyde-pdp__stock-text--out');
    if (backorder) {
      stockDotEl.classList.add('hyde-pdp__stock-dot--low');
      stockTextEl.classList.add('hyde-pdp__stock-text--low');
      stockTextEl.textContent = 'Available to Order';
      if (shipsEl) {
        shipsEl.hidden = false;
        shipsEl.style.display = '';
        shipsEl.textContent = 'Dispatch timing confirmed after order';
      }
    } else if (variant.available) {
      if (variant.inventory_quantity > 10) {
        stockTextEl.textContent = 'In Stock';
      } else if (variant.inventory_quantity > 0) {
        stockDotEl.classList.add('hyde-pdp__stock-dot--low');
        stockTextEl.classList.add('hyde-pdp__stock-text--low');
        stockTextEl.textContent = 'Only ' + variant.inventory_quantity + ' left';
      } else {
        stockTextEl.textContent = 'In Stock';
      }
      if (shipsEl) {
        shipsEl.hidden = false;
        shipsEl.style.display = '';
        shipsEl.textContent = 'Eligible orders dispatch same day · free over $30';
      }
    } else {
      stockDotEl.classList.add('hyde-pdp__stock-dot--out');
      stockTextEl.classList.add('hyde-pdp__stock-text--out');
      stockTextEl.textContent = 'Out of Stock';
      if (shipsEl) shipsEl.style.display = 'none';
    }
  }

  function applyVariant(variant) {
    if (!variant) return;
    var backorder = isBackorder(variant);
    if (variantIdInput) variantIdInput.value = variant.id;
    baseCents = variant.price;
    compareCents = variant.compare_at || 0;
    validateScheduleForVariant(variant);
    if (addToCartBtn) {
      addToCartBtn.disabled = !variant.available;
      addToCartBtn.textContent = backorder ? 'Add to Order'
        : (variant.available ? 'Add to Cart' : 'Sold Out');
      cartBtnLabel = addToCartBtn.textContent;
    }
    if (stickyBtn) {
      stickyBtn.disabled = !variant.available;
      stickyBtn.textContent = backorder ? 'Add to Order'
        : (variant.available ? 'Add to Cart' : 'Sold Out');
    }
    if (paymentButtonEl) paymentButtonEl.style.display = variant.available ? '' : 'none';
    updateStock(variant);
    updateTotal();
  }
  
  var qtyInput = document.getElementById('hyde-qty');
  if (qtyInput) {
    qtyInput.addEventListener('change', updateTotal);
    qtyInput.addEventListener('input', updateTotal);
  }
  if (variantSelect && variants && variants.length) {
    variantSelect.addEventListener('change', function() {
      var id = parseInt(variantSelect.value, 10);
      var variant = variants.find(function(v) { return v.id === id; });
      applyVariant(variant);
    });
    applyVariant(variants.find(function(v) { return v.id === activeVariantId; }) || variants[0]);
  } else if (variants && variants.length) {
    validateScheduleForVariant(variants.find(function(v) { return v.id === activeVariantId; }) || variants[0]);
  }
  updateTotal();
  
  // Gallery thumbnails — with srcset support
  var thumbs = document.querySelectorAll('.hyde-pdp__gallery-thumb');
  var mainImg = document.getElementById('hyde-main-img');
  var counter = document.querySelector('.hyde-pdp__gallery-counter');
  var total = thumbs.length;

  thumbs.forEach(function(t) {
    t.addEventListener('click', function() {
      thumbs.forEach(function(x) {
        x.classList.remove('active');
        x.setAttribute('aria-selected', 'false');
      });
      t.classList.add('active');
      t.setAttribute('aria-selected', 'true');
      mainImg.src = t.dataset.img;
      // Update srcset for responsive images
      if (t.dataset.srcset) {
        mainImg.srcset = t.dataset.srcset;
      }
      if (counter) counter.textContent = t.dataset.idx + ' / ' + total;
    });
  });
  
  function setActivePanel(panelName) {
    if (!panelName) return;
    document.querySelectorAll('.hyde-pdp__tab-btn').forEach(function(x) {
      x.setAttribute('aria-selected', x.dataset.tab === panelName ? 'true' : 'false');
    });
    document.querySelectorAll('.hyde-pdp__tab-panel').forEach(function(p) {
      p.dataset.active = p.dataset.panel === panelName ? 'true' : 'false';
    });
    document.querySelectorAll('.hyde-pdp__tab-section').forEach(function(section) {
      section.dataset.open = section.dataset.panel === panelName ? 'true' : 'false';
    });
    document.querySelectorAll('.hyde-pdp__accordion-btn').forEach(function(btn) {
      btn.setAttribute('aria-expanded', btn.dataset.panel === panelName ? 'true' : 'false');
    });
  }

  // Desktop tabs
  document.querySelectorAll('.hyde-pdp__tab-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      setActivePanel(btn.dataset.tab);
    });
  });

  // Mobile accordion
  document.querySelectorAll('.hyde-pdp__accordion-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var section = btn.closest('.hyde-pdp__tab-section');
      if (!section) return;
      var isOpen = section.dataset.open === 'true';
      if (isOpen) {
        section.dataset.open = 'false';
        btn.setAttribute('aria-expanded', 'false');
        var panel = section.querySelector('.hyde-pdp__tab-panel');
        if (panel) panel.dataset.active = 'false';
        return;
      }
      setActivePanel(btn.dataset.panel);
    });
  });

  var initialTab = null;
  var selectedTab = document.querySelector('.hyde-pdp__tab-btn[aria-selected=\"true\"]');
  if (selectedTab) initialTab = selectedTab.dataset.tab;
  if (!initialTab) initialTab = 'details';
  setActivePanel(initialTab);
  
  // Sticky bar visibility
  var stickyBar = document.getElementById('hyde-sticky-bar');
  var cartBtn = document.querySelector('.hyde-pdp__cart-btn');

  if (stickyBar && cartBtn) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('visible');
        } else {
          stickyBar.classList.add('visible');
        }
      });
    }, { threshold: 0, rootMargin: '-100px 0px 0px 0px' });

    observer.observe(cartBtn);
  }

  // Quantity +/- buttons
  document.querySelectorAll('.hyde-pdp__qty-btn[data-qty-delta]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var delta = parseInt(btn.dataset.qtyDelta, 10);
      if (!isNaN(delta)) window.hydeQty(delta);
    });
  });

  // AJAX add-to-cart: keeps the buyer on the PDP, updates the header count,
  // and shows inline next actions. Falls back to native submit on any error.
  var productForm = document.getElementById('hyde-product-form');

  function setHeaderCount(count) {
    var badge = document.querySelector('.hyde-header-action__count');
    if (badge) {
      badge.textContent = count;
    } else {
      var cartAction = document.querySelector('a[href="/cart"].hyde-header-action, .hyde-header-action--cart');
      if (cartAction) {
        badge = document.createElement('span');
        badge.className = 'hyde-header-action__count';
        badge.textContent = count;
        cartAction.appendChild(badge);
      }
    }
  }

  var cartBtnLabel = cartBtn ? cartBtn.textContent : '';

  function showAddedState() {
    if (cartBtn) {
      cartBtn.textContent = '✓ Added to Cart';
      cartBtn.disabled = true;
    }
    var actions = document.getElementById('hyde-added-actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.id = 'hyde-added-actions';
      actions.className = 'hyde-pdp__added-actions';
      actions.innerHTML = '<a class="hyde-pdp__added-link" href="/cart">View Cart</a>'
        + '<a class="hyde-pdp__added-link hyde-pdp__added-link--checkout" href="/checkout">Checkout</a>';
      productForm.appendChild(actions);
    }
    actions.style.display = '';
    setTimeout(function() {
      if (cartBtn) {
        cartBtn.textContent = cartBtnLabel;
        cartBtn.disabled = false;
      }
    }, 2500);
  }

  var ajaxInFlight = false;
  if (productForm && window.fetch) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      if (ajaxInFlight || (cartBtn && cartBtn.disabled)) return;
      ajaxInFlight = true;
      var added = false;
      if (window.HydeTierContract) window.HydeTierContract.prepareForm(productForm);
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(productForm),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function(res) {
        if (!res.ok) throw new Error('add failed: ' + res.status);
        // The add reached the server successfully: from here on any failure
        // must degrade gracefully, never re-submit (double-add).
        added = true;
        return res.json();
      }).then(function() {
        ajaxInFlight = false;
        showAddedState();
        return fetch('/cart.js')
          .then(function(r) {
            if (!r.ok) throw new Error('readback failed');
            return r.json();
          })
          .then(function(cart) { setHeaderCount(cart.item_count); })
          .catch(function() { /* badge update skipped; add already succeeded */ });
      }).catch(function() {
        ajaxInFlight = false;
        if (added) return;
        // Native fallback only when the add itself failed
        productForm.submit();
      });
    });
  }

  // Sticky-bar purchase control submits only a sellable variant.
  if (stickyBtn && productForm) {
    stickyBtn.addEventListener('click', function() {
      if (stickyBtn.disabled || (cartBtn && cartBtn.disabled)) return;
      if (typeof productForm.requestSubmit === 'function') {
        productForm.requestSubmit();
      } else {
        productForm.submit();
      }
    });
  }
})();
